
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
// @ts-ignore
import ClickOutside from "vue-click-outside";

import { Container } from "inversify";
import { OrganizationListStore } from "../../../stores/organization/OrganizationListStore";
import { SelectOption } from "../../../../../landing/src/molecules/form/types";
import {
    isAdmin,
    isQuiltySubscribed,
    isSubscribed,
    isThirdpartyAdmin,
    MAX_FREE_ORGANIZATION_SEARCH,
} from "@gsx/common";
import { debounce } from "lodash";
import FormMultiSelect from "../../../../../landing/src/molecules/form/FormMultiSelect.vue";
import { OrganizationItem } from "@gsx/common/src/types/http/dashboard/organization";
import { OrganizationStore } from "../../../stores/organization/OrganizationStore";
import { QuiltyInsightsListStore } from "../../../stores/quiltyInsights/QuiltyInsightsListStore";
import { OrganizationProjectsCollectionStore } from "../../../stores/organization/resource/OrganizationProjectsCollectionStore";
import { handleError } from "../../../../../common/src/utility/errorUtils";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { event } from "vue-gtag";

@Component({
    directives: { ClickOutside },
    components: { FormMultiSelect },
})
export default class OrganizationMobileNavigation extends Vue {
    @Inject("container") container!: Container;
    readonly organizationItemStore: OrganizationStore = this.container.get(OrganizationStore);

    readonly organizationListStore: OrganizationListStore =
        this.container.get(OrganizationListStore);
    readonly quiltyInsightsListStore: QuiltyInsightsListStore =
        this.container.get(QuiltyInsightsListStore);
    readonly organizationProjectsStore: OrganizationProjectsCollectionStore = this.container.get(
        OrganizationProjectsCollectionStore,
    );
    readonly authStore: AuthStore = this.container.get(AuthStore);

    created() {
        if (this.quiltyInsightsListStore.organizationId !== this.organizationId) {
            this.quiltyInsightsListStore.organizationId = this.organizationId;
            this.quiltyInsightsListStore.reload().catch(handleError);
        }
    }

    get organizationId(): string {
        return this.$route.params.organization;
    }

    get organization(): OrganizationItem | null {
        return this.organizationItemStore.item;
    }

    get organizationUrl() {
        return `/organizations/${this.organizationId}`;
    }

    get hasAdminAccess() {
        const user = this.authStore.user;
        return isAdmin(user);
    }

    get hasThirdpartyAdminAccess() {
        const user = this.authStore.user;
        return isThirdpartyAdmin(user);
    }

    get hasSearches() {
        let showOrgs = true;
        const tracker = this.authStore.user!.organizationSearchTracker;
        if (
            tracker &&
            !this.hasAdminAccess &&
            !this.hasThirdpartyAdminAccess &&
            !isSubscribed(this.authStore.user) &&
            !isQuiltySubscribed(this.authStore.user)
        ) {
            if (
                new Date(tracker.date).getMonth() === new Date().getMonth() &&
                tracker.count >= MAX_FREE_ORGANIZATION_SEARCH
            ) {
                showOrgs = false;
            }
        }

        return showOrgs;
    }

    get organizationOptions(): SelectOption[] {
        let orgs = (this.organizationListStore.items || []).map((organization) => ({
            id: organization.organizationid,
            name: organization.organizationName,
        }));

        return this.hasSearches ? orgs : [];
    }

    navigateToOrganization(option: SelectOption) {
        this.$router.push(`/organizations/${option.id}`);
    }

    updateSearchDebounce = debounce(this.updateSearch, 600);

    updateSearch(query: string) {
        event("Search", {
            eventCategory: "Search",
            eventAction: "nav search",
            eventLabel: query,
        });
    }

    profileNavigation = [
        {
            label: "Personal Information",
            to: "/profile",
        },
        {
            label: "Subscriptions",
            to: "/profile/subscriptions",
        },
        {
            label: "My Requests",
            to: "/profile/requests",
        },
        {
            label: "Affiliations",
            to: "/profile/affiliations",
        },
        {
            label: "Password Reset",
            to: "/profile/password-reset",
        },
        {
            label: "Logout",
            action: this.signout,
        },
    ];

    async signout() {
        await this.authStore.signout();
        window.location.href = "/";
    }

    @Watch("organizationId")
    load() {
        this.organizationProjectsStore.load(this.organizationId).catch(handleError);

        this.quiltyInsightsListStore.organizationId = this.organizationId;
        this.quiltyInsightsListStore.reload().catch(handleError);
    }
}
